import React from 'react';

const renderInquiryRow = (inquiry, handleStatusChange, openMessageModal) => (
  <tr key={inquiry.id} className="hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors duration-150">
    <td className="px-6 py-4 whitespace-nowrap">
      <div className="text-sm font-medium text-gray-900 dark:text-white">{inquiry.property_type}</div>
      <div className="text-sm text-gray-600 dark:text-gray-400">{inquiry.area} sq ft</div>
    </td>
    <td className="px-6 py-4 whitespace-nowrap">
      <div className="text-sm text-gray-900 dark:text-white">{inquiry.email}</div>
      {inquiry.phone && <div className="text-sm text-gray-600 dark:text-gray-400">{inquiry.phone}</div>}
    </td>
    <td className="px-6 py-4 text-sm text-gray-800 dark:text-gray-200 max-w-xs truncate cursor-pointer" onClick={() => openMessageModal(inquiry)}>
      {inquiry.location}
    </td>
    <td className="px-6 py-4 whitespace-nowrap">
      <select
        value={inquiry.status}
        onChange={(e) => handleStatusChange(inquiry.id, e.target.value)}
        className={`text-sm rounded-md border-gray-300 dark:border-gray-700 shadow-sm py-1 px-2
                    ${inquiry.status === 'new' ? 'bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900 dark:text-blue-300 dark:border-blue-700' :
          inquiry.status === 'in-progress' ? 'bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-900 dark:text-yellow-300 dark:border-yellow-700' :
            'bg-green-100 text-green-800 border-green-300 dark:bg-green-900 dark:text-green-300 dark:border-green-700'}
                    focus:ring-primary-500 focus:border-primary-500`}
      >
        <option value="new">New</option>
        <option value="in-progress">In Progress</option>
        <option value="completed">Completed</option>
      </select>
    </td>
    <td className="px-6 py-4 text-sm text-gray-500 dark:text-gray-400">
      {new Date(inquiry.created_at).toLocaleDateString()}
    </td>
  </tr>
);

const renderInquiryCard = (inquiry, handleStatusChange, openMessageModal) => (
  <div key={inquiry.id} className="bg-white dark:bg-gray-900 rounded-lg shadow-md p-4 mb-4 border border-gray-200 dark:border-gray-700">
    <div className="mb-2">
      <strong className="text-xs uppercase text-gray-500 dark:text-gray-400 block">Property Type</strong>
      <div className="text-sm font-medium text-gray-900 dark:text-white">{inquiry.property_type}</div>
      <div className="text-sm text-gray-600 dark:text-gray-400">{inquiry.area} sq ft</div>
    </div>
    <div className="mb-2">
      <strong className="text-xs uppercase text-gray-500 dark:text-gray-400 block">Contact Info</strong>
      <div className="text-sm text-gray-900 dark:text-white">{inquiry.email}</div>
      {inquiry.phone && <div className="text-sm text-gray-600 dark:text-gray-400">{inquiry.phone}</div>}
    </div>
    <div className="mb-2">
      <strong className="text-xs uppercase text-gray-500 dark:text-gray-400 block">Message / Details</strong>
      <div className="text-sm text-gray-800 dark:text-gray-200 max-w-full truncate cursor-pointer" onClick={() => openMessageModal(inquiry)}>
        {inquiry.location}
      </div>
    </div>
    <div className="mb-2">
      <strong className="text-xs uppercase text-gray-500 dark:text-gray-400 block">Status</strong>
      <select
        value={inquiry.status}
        onChange={(e) => handleStatusChange(inquiry.id, e.target.value)}
        className={`text-sm rounded-md border-gray-300 dark:border-gray-700 shadow-sm py-1 px-2
                    ${inquiry.status === 'new' ? 'bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900 dark:text-blue-300 dark:border-blue-700' :
          inquiry.status === 'in-progress' ? 'bg-yellow-100 text-yellow-800 border-yellow-300 dark:bg-yellow-900 dark:text-yellow-300 dark:border-yellow-700' :
            'bg-green-100 text-green-800 border-green-300 dark:bg-green-900 dark:text-green-300 dark:border-green-700'}
                    focus:ring-primary-500 focus:border-primary-500`}
      >
        <option value="new">New</option>
        <option value="in-progress">In Progress</option>
        <option value="completed">Completed</option>
      </select>
    </div>
    <div>
      <strong className="text-xs uppercase text-gray-500 dark:text-gray-400 block">Date</strong>
      <div className="text-sm text-gray-500 dark:text-gray-400">
        {new Date(inquiry.created_at).toLocaleDateString()}
      </div>
    </div>
  </div>
);

const ValuationRequests = ({ inquiries, handleStatusChange, openMessageModal }) => {
  return (
    <>
      <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 hidden md:table">
        <thead className="bg-gray-100 dark:bg-gray-800">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">Property Type</th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">Contact Info</th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">Message / Details</th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">Status</th>
            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider">Date</th>
          </tr>
        </thead>
        <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-100 dark:divide-gray-800">
          {inquiries.length > 0 ? (
            inquiries.map((inquiry) => renderInquiryRow(inquiry, handleStatusChange, openMessageModal))
          ) : (
            <tr>
              <td colSpan={5} className="px-6 py-10 text-center text-lg text-gray-500 dark:text-gray-400">
                No inquiries found for this category and filter.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="md:hidden p-4 space-y-4">
        {inquiries.length > 0 ? inquiries.map(inquiry => renderInquiryCard(inquiry, handleStatusChange, openMessageModal)) : (
          <div className="px-6 py-10 text-center text-lg text-gray-500 dark:text-gray-400">
            No inquiries found for this category and filter.
          </div>
        )}
      </div>
    </>
  );
};

export default ValuationRequests;